import {
    getConfiCostIdLoading,
    getConfiCostIdRequest,
    getConfiCostIdSuccess,
    getConfiCostIdReject,
} from "../../actions/costGlobal/getId";

export const getConfiCostId = (formData) => async (dispatch, getState) => {
    dispatch(getConfiCostIdLoading());
    try {
        const { data } = await getConfiCostIdRequest(formData, getState);
        dispatch(getConfiCostIdSuccess(data))
    } catch (error) {
        dispatch(getConfiCostIdReject(error))
    }
    return Promise.resolve();
};